import React from "react";

/**
 * Shared polished empty-state panel for Employer Hub sections.
 */
export const HubEmptyPanel = ({ icon: Icon, title, body, action, testid }) => (
  <div
    className="bg-white border border-gray-200 rounded-2xl px-8 py-16 sm:py-20 text-center max-w-2xl mx-auto"
    data-testid={testid}
  >
    {Icon && (
      <div className="mx-auto mb-6 h-12 w-12 rounded-full bg-blue-50 flex items-center justify-center">
        <Icon className="h-6 w-6 text-blue-600" />
      </div>
    )}
    <h2 className="text-lg font-semibold text-gray-900 mb-2">{title}</h2>
    <p className="text-sm text-gray-500 leading-relaxed max-w-md mx-auto">{body}</p>
    {action && <div className="mt-8">{action}</div>}
  </div>
);
